<template>
  <v-footer padless class="footer">
    <v-card
      width="100%"
      tile
      flat
      class="footer_header"
      color="light-blue darken-3"
    >
    </v-card>
    <v-card
      width="100%"
      tile
      flat
      dark
      class="pa-2"
      color="light-blue darken-4"
    >
      <v-container class="d-flex justify-center">
        <v-row align="center" justify="center" class="footer_title px-4">
          <!-- Copy Link Button -->
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                outlined
                fab
                x-small
                v-bind="attrs"
                v-on="on"
                @click="copyCurrentLink"
                class="mx-2"
              >
                <v-icon>fa-link</v-icon>
              </v-btn>
            </template>
            <span>Copy current page link and share with others</span>
          </v-tooltip>

          <!-- Copy Embed Code Button -->
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                outlined
                fab
                x-small
                v-bind="attrs"
                v-on="on"
                @click="copyEmbedCode"
                class="mx-2"
              >
                <v-icon>fa-anchor</v-icon>
              </v-btn>
            </template>
            <span>Copy iframe block to embed on an external website</span>
          </v-tooltip>

          <!-- Vertical Divider -->
          <v-divider vertical class="mx-4" inset></v-divider>

          <!-- SportEcos Text -->
          <strong>
            <a
              :href="currentDomain"
              rel="noopener"
              target="_blank"
              class="text-white"
            >
              {{ new Date().getFullYear() }} — SportEcos
            </a>
          </strong>

          <!-- Vertical Divider -->
          <v-divider vertical class="mx-4" inset></v-divider>

          <!-- Social Media Buttons -->
          <v-row no-gutters class="ml-4">
            <v-col v-for="social in socialItems" :key="social.icon" cols="auto">
              <a :href="social.link" class="text-decoration-none">
                <v-btn outlined dark fab x-small>
                  <v-icon>{{ social.icon }}</v-icon>
                </v-btn>
              </a>
            </v-col>
          </v-row>
        </v-row>
        <!-- <socialSharing/> -->
      </v-container>
    </v-card>
  </v-footer>
</template>


<script>
import socialSharing from "./social_sharing.vue";
export default {
  components: { socialSharing },
  data() {
    return {
      socialItems: [
        {
          icon: "fab fa-facebook",
          link: "https://www.facebook.com/SportEcoSys/",
        },
        { icon: "fab fa-twitter", link: "https://twitter.com/SportEcoSys" },
        { icon: "fab fa-telegram", link: "https://t.me/SportEcoSys" },
        { icon: "fas fa-envelope", link: "mailto:info@sportecos.com" },
        //  { icon: "fab fa-instagram", link: "" },
        //  { icon: "fab fa-linkedin", link: "" },
        //  { icon: "fab fa-google-plus", link: "" },
      ],
      ogLinks: [
        { title: "Home", href: "/" },
        { title: "Services", href: "/" },
        { title: "About Us", href: "/" },
        //  { title: 'Contact Us:' },
      ],
    };
  },
  computed: {
    currentDomain() {
      return window.location.origin; // Dynamically gets the site URL
    },
  },
  methods: {
    copyCurrentLink() {
      navigator.clipboard
        .writeText(window.location.href)
        .then(() => {
          this.$toast.success("Link has been copied");
        })
        .catch((error) => {
          console.error(error);
        });
    },
    copyEmbedCode() {
      const embedCode = `<iframe src="${this.currentDomain}/embed" width="600" height="400" frameborder="0"></iframe>`;
      navigator.clipboard
        .writeText(embedCode)
        .then(() => alert("Embed code copied!"))
        .catch((err) => console.error("Error copying embed code:", err));
    },
  },
};
</script>
<style lang="scss">
.footer {
  li {
    list-style: none;
  }

  &_header-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .v-expansion-panel-header {
      transition: ease-in 0.3s !important;
    }

    .socialSharign_wrapper {
      span:hover {
        i {
          color: red !important;
        }
      }
    }

    .v-expansion-panel-content__wrap {
      padding: 0 !important;
    }

    .v-expansion-panel-header:hover {
      background-color: white !important;
      color: #0277bd !important;
    }

    div {
      width: 100%;
    }
  }

  &_nav-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;

    div {
      text-align: center;
      padding: 5px 15px;
      transition: ease-in 0.3s;

      a {
        font-size: 15px;
        font-weight: bold;
        color: white;
      }
    }

    div:hover {
      background-color: white;

      a {
        color: #0277bd;
      }
    }
  }

  &_nav {
    max-width: calc(100% / 2);

    nav {
      width: 100%;
    }
  }

  &_social {
    width: 100%;
  }

  &_social-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    div {
      text-align: center;
      transition: ease-in 0.3s;
    }

    div:hover {
      background-color: white;

      button {
        color: #0277bd !important;
      }
    }
  }

  &_social-sharign-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  &_social-title {
    color: white;
    transition: ease-in 0.3s;
  }

  &_social-title:hover {
    background-color: white;
    color: #0277bd;
    padding: 20px 0;
  }

  &_about {
    max-width: calc(100% / 2);
  }

  &_about-info {
    color: white;
    font-size: 13px;
  }

  &_about-title {
    color: white;
    padding: 15px 0;
  }
}
</style>
